// extracted by mini-css-extract-plugin
export default {"drawer":"gU","drawerheader":"hU","retake_quiz_bottom_bar":"iU","extra_drawer":"jU","not_answered_questions":"kU","question_ui":"lU","accordion_details":"mU","retake_quiz":"nU","accordions":"oU","accordion_root":"pU","accordion_summary_text":"qU","animation":"rU","show_animation":"sU","overflow_hidden":"tU"};
    if(module.hot) {
      // 1715632478806
      var cssReload = require("../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  